module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0144.jpg?v=e9be0021";